import { setDefaultOptions } from 'date-fns';
import { ru } from 'date-fns/locale';

export const applyGlobalConfigDateFns = () => {
  setDefaultOptions({ locale: ru });
};
